import { useQuery } from '@tanstack/react-query'

import { getShipmentBookmarks } from '@/features/auth'

export const useGetShipmentBookmarks = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['getShipmentBookmarks'],
    queryFn: getShipmentBookmarks,
    select: (data) => data.owner,
    enabled: enabled,
  })
}
